import React from "react"
import { Box, BoxProps } from "@chakra-ui/core"

type DetailsItemProps = BoxProps & {}

export default function DetailsItem({ ...props }: DetailsItemProps) {
  return <Box as="span" d="block" {...props} />
}
